import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import React, {useRef, useState} from "react";
import {css} from "@emotion/css";
import {RouteInfo} from "../../../route/RouteHelper";
import {useLocation, useNavigate} from "react-router-dom";
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {LoginService} from "../../../connection-services/login/LoginService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {Helmet} from "react-helmet";
import {RaikoButtonPrimary, RaikoNumberInputOutlined} from "@moeindal/base-raiko-panel-components";

const SignInForgetPassword = () => {

    const {state} = useLocation()

    const service = new LoginService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [nationalCode, setNationalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState(state && state.phoneNumber ? state.phoneNumber : "")

    const reCaptchaRef = useRef(undefined);
    const [recaptchaGeneratedKey, setRecaptchaGeneratedKey] = useState(null);

    const navigate = useNavigate()

    /* const handleGenerateRecaptcha = () => {
         return new Promise(async (resolve, reject) => {

             if (recaptchaGeneratedKey) {
                 setRecaptchaGeneratedKey(null)
                 window.grecaptcha.reset();
             }

             let newVar = await reCaptchaRef.current.executeAsync();

             resolve(newVar)
         })
     }*/

    function sendOtpSms() {
        if (phoneNumber.length === 11 && nationalCode >= 8) {
            loading.show()
            service.sendOtpSmsForgetPassword(phoneNumber, nationalCode)
                .then(response => {
                    snackbar.showSuccessMessage("کد تایید با موفقیت ارسال شد.")
                    navigate(RouteInfo.SignInRefreshPassword.globalUrl, {state: {phoneNumber, nationalCode}})
                }).catch(reason => {
                snackbar.showServerErrorMessage(reason, "خطا در ارسال کد تایید.")
            }).finally(_ => {
                loading.hide()
            })
        } else {
            snackbar.showWarningMessage("لطفا کد ملی و شماره ی همراه خود را به درستی وارد نمایید.")
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.SignInForgetPassword.name}</title>
            </Helmet>
            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>فراموشی رمز عبور</span>
                </div>
                <form className={"signInContentContainer"}>
                    <span className={"subTitle"}>لطفا شماره ی همراه خود را وارد نمایید.</span>

                    <RaikoNumberInputOutlined
                        labelText={"شماره ملی"}
                        setValue={value => {
                            if (value.length < 11) {
                                setNationalCode(value)
                            }
                        }}
                        value={nationalCode}
                    />
                    <RaikoNumberInputOutlined
                        labelText={"شماره همراه"}
                        setValue={value => {
                            if (value.length < 12) {
                                setPhoneNumber(value)
                            }
                        }}
                        value={phoneNumber}
                    />

                    <RaikoButtonPrimary
                        label={"تایید"}
                        className={css`
                          width: 100%;
                          margin-top: .5rem;
                        `}
                        onClick={sendOtpSms}/>

                    <span className={"forgetPassword"} onClick={_ => {
                        navigate(RouteInfo.SignInEnterPhoneNumber.globalUrl, {replace: true})
                    }}>
                    ورود به سامانه
                </span>
                </form>
            </div>
        </>
    )
}


export default SignInForgetPassword;